import { useMutation, useQuery } from '@apollo/client';
import i18next from 'i18next';
import { useState } from 'react';
import { useUser } from '../base/components/UserProvider/useUserHook';
import {
  ChangeLanguageDocument,
  LanguagesDocument,
} from '../graphql/graphql-operations';
import { LANGUAGES } from '../lib/constants';

export function useLanguage() {
  const [language, setLanguage] = useState(i18next.language);
  i18next.on('languageChanged', (lng) => setLanguage(lng));
  return language;
}

export function useChangeUserLanguage(onCompleted?: () => void) {
  const { data } = useQuery(LanguagesDocument);
  const { user } = useUser();
  const [changeLanguage, { client }] = useMutation(ChangeLanguageDocument, {
    onCompleted: (data) => {
      const userLang = data.changeLanguage.languageCode;
      if (userLang !== i18next.languages[0]) {
        i18next.changeLanguage(userLang);
      }
      client.resetStore();
      if (onCompleted) {
        onCompleted();
      }
    },
  });

  const handleLanguageChange = (lang?: string) => {
    const language = i18next.languages[0];
    let languageCode = lang;
    if (!languageCode) {
      const idx = LANGUAGES.indexOf(language);
      if (idx + 1 < LANGUAGES.length) {
        languageCode = LANGUAGES[idx + 1];
      }
    }
    languageCode = languageCode || 'en';

    const isSupported = data?.languages.find((l) => l.code === languageCode);
    setLangCookie(languageCode);
    if (isSupported && user) {
      changeLanguage({
        variables: {
          changeLanguageInput: {
            languageCode,
          },
        },
      });
    } else {
      i18next.changeLanguage(languageCode);
    }
  };

  return [handleLanguageChange];
}

export const setLangCookie = (languageCode: string) => {
  document.cookie = `languageCode=${languageCode}; expires=Fri, 31 Dec 9999 23:59:59 GMT; SameSite=None; Secure=false;`;
};
